import { useState } from 'react';

export default function Solutions() {
  const [activeIndex, setActiveIndex] = useState(0);

  const solutions = [
    {
      icon: 'ri-rocket-line',
      title: 'Startup Launch',
      description: 'Complete business setup from concept to market entry',
      features: ['Business Planning', 'Brand Identity', 'Website Development', 'Market Strategy']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Growth Acceleration',
      description: 'Scale your operations with data-driven insights',
      features: ['Data Analytics', 'Process Optimization', 'Market Expansion', 'Performance Tracking']
    },
    {
      icon: 'ri-refresh-line',
      title: 'Digital Transformation',
      description: 'Modernize your business with cutting-edge technology',
      features: ['System Integration', 'Cloud Migration', 'Automation', 'Digital Tools']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Compliance & Finance',
      description: 'Stay compliant and financially organized',
      features: ['Tax Compliance', 'Financial Systems', 'VAT Registration', 'Bookkeeping']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="w-full px-4 sm:px-8 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3782df]/10 rounded-full mb-6">
            <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
            <span className="text-[#3782df] text-sm font-medium">Solutions</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Tailored Solutions for Every Stage
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Whether you're launching, scaling, or transforming — we provide the right mix of services to meet your business where it is.
          </p>
        </div>

        {/* Solutions Carousel */}
        <div className="relative">
          {/* Navigation Dots */}
          <div className="flex justify-center gap-2 mb-8">
            {solutions.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  activeIndex === index ? 'bg-[#3782df] w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Cards Container - Horizontal Scroll on Mobile */}
          <div className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide lg:grid lg:grid-cols-4 lg:overflow-visible">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className={`flex-shrink-0 w-[85vw] sm:w-[400px] lg:w-auto bg-white rounded-xl p-6 shadow-lg border-2 transition-all duration-300 snap-center ${
                  activeIndex === index ? 'border-[#3782df]' : 'border-gray-100'
                }`}
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-lg flex items-center justify-center mb-4 transition-colors ${
                  activeIndex === index ? 'bg-[#3782df]' : 'bg-[#3782df]/10'
                }`}>
                  <i className={`${solution.icon} text-2xl transition-colors ${
                    activeIndex === index ? 'text-white' : 'text-[#3782df]'
                  }`}></i>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {solution.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                  {solution.description}
                </p>

                {/* Features */}
                <div className="space-y-2">
                  {solution.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#3782df]"></i>
                      </div>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows - Hidden on Mobile */}
          <button
            onClick={() => setActiveIndex((prev) => (prev === 0 ? solutions.length - 1 : prev - 1))}
            className="hidden lg:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 w-12 h-12 items-center justify-center bg-white rounded-full shadow-lg border border-gray-200 hover:bg-gray-50 transition-colors"
            aria-label="Previous solution"
          >
            <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
          </button>
          <button
            onClick={() => setActiveIndex((prev) => (prev === solutions.length - 1 ? 0 : prev + 1))}
            className="hidden lg:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 w-12 h-12 items-center justify-center bg-white rounded-full shadow-lg border border-gray-200 hover:bg-gray-50 transition-colors"
            aria-label="Next solution"
          >
            <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>
    </section>
  );
}